import React from 'react';
import classes from './SliderComponent.module.scss';

export default function GameCarousel({ items }) {
  return (
    <div className={`${classes.scrollContainer}`}>
      {items.map((item, index) => (
        <div key={index} className={classes.carouselItem}>
          {item}
        </div>
      ))}
    </div>
  );
}
